import React from 'react';
import './BrandFeatureLocks.css';

/**
 * Admin → Brands → Features. Which menu features this brand has unlocked.
 * Locked ones stay in the brand's menu, grayed out, and open a preview asking
 * members to speak to their brand owner. Saved with the brand's Save button.
 */
/** Brand-neutral names here: each brand shows its own "<Brand> Results" to members. */
const LABELS = { brand_results: 'Results' };
const labelFor = (f) => LABELS[f.key] || f.label;

/** RiskLo-wide switches (the intro tour) aren't per-brand plan features. */
const NOT_LOCKABLE = new Set(['Global']);

export default function BrandFeatureLocks({ features: allFeatures, locked, onChange }) {
  const features = (allFeatures || []).filter((f) => !NOT_LOCKABLE.has(f.group));
  if (!features.length) return null;
  const lockedSet = new Set(locked || []);
  const groups = [...new Set(features.map((f) => f.group))];
  const toggle = (key) => {
    const next = new Set(lockedSet);
    if (next.has(key)) next.delete(key); else next.add(key);
    onChange([...next]);
  };
  const unlockedCount = features.filter((f) => !lockedSet.has(f.key)).length;

  return (
    <div className="bfl">
      <div className="bfl-head">
        <h3 className="bfl-title">Features</h3>
        <span className="bfl-count">{unlockedCount} of {features.length} unlocked</span>
        <button type="button" className="ae-btn bfl-bulk" onClick={() => onChange([])}>Unlock all</button>
        <button type="button" className="ae-btn bfl-bulk" onClick={() => onChange(features.map((f) => f.key))}>Lock all</button>
      </div>
      <p className="bfl-note">
        Locked features stay in this brand&apos;s menu, grayed out, and show a preview asking members to
        speak to their brand owner. Full Admins always see the real page. Who sees each feature by tier
        is still set on the Users page.
      </p>
      {groups.map((group) => (
        <div key={group} className="bfl-group">
          <div className="bfl-group-title">{group}</div>
          <ul className="bfl-list">
            {features.filter((f) => f.group === group).map((f) => {
              const isLocked = lockedSet.has(f.key);
              return (
                <li key={f.key}>
                  <button
                    type="button"
                    role="switch"
                    aria-checked={!isLocked}
                    className={`bfl-item${isLocked ? ' is-locked' : ''}`}
                    onClick={() => toggle(f.key)}
                  >
                    <span className="bfl-switch" aria-hidden="true"><span /></span>
                    <span className="bfl-label">{labelFor(f)}</span>
                    <span className="bfl-state">{isLocked ? 'Locked' : 'Unlocked'}</span>
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </div>
  );
}
